import { create } from "zustand";
import { UserStore } from "@/lib/definitions";

interface UserState {
  user: UserStore | undefined;
}

interface UserActions {
  setUser: (user: UserStore | undefined) => void;
}

const useUserStore = create<UserState & UserActions>((set) => ({
  user: undefined,
  setUser: (user) => set({ user }),
}));

export default useUserStore;
